import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { MODAL_TYPES, useWizrModalContext } from '../../providers/modal/WizrModalProvider';

interface SharePointFile {
  id: string;
  name: string;
  webUrl: string;
  size: number;
  lastModified: string;
}

interface SharePointSite {
  id: string;
  name: string;
  webUrl: string;
}

const SharePointPicker: React.FC = () => {
  const [sitessharepoint, setSites] = useState<SharePointSite[]>([]);
  const [accessToken, setAccessToken] = useState('');
  const [currentFolderId, setCurrentFolderId] = useState<string>('');
  const navigate = useNavigate();
  const location = useLocation();
  const { showModal } = useWizrModalContext();


  useEffect(() => {
    // Get folderId from sessionStorage
    const folderId = sessionStorage.getItem('current_folder_id');
    console.log("Retrieved folderId in SharePointPicker:", folderId);
    setCurrentFolderId(folderId || '');
  }, []);
  console.log("currentFolderId in sharepointpicker", currentFolderId);

  useEffect(() => {
    const hash = location.hash;
    if (hash && !accessToken) {
      const token = new URLSearchParams(hash.substring(1)).get('access_token');
      console.log("token in sharepointpicker", token);
      if (token) {
        setAccessToken(token);
        navigate('/sharepoint', { replace: true });
        fetchSharePointSites(token);
        showModal(MODAL_TYPES.SHAREPOINT_UPLOAD, {
          accessToken: token,
          folderId: currentFolderId  // Pass the folderId to the modal
        });
        console.log("Passing folderId to modal in SharePointPicker:", currentFolderId);
      }
    }
  }, [accessToken, location.hash, navigate, currentFolderId]);
  console.log("folderId in sharepointpicker", currentFolderId)

  const fetchSharePointSites = async (token: string) => {
    try {
      const response = await axios.get(
        'https://graph.microsoft.com/v1.0/sites?search=*',
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      console.log("response in fetchSharePointSites inside sharepointpicker",response)

      setSites(response.data.value.map((site: any) => ({
        id: site.id,
        name: site.displayName,
        webUrl: site.webUrl
      })));
    } catch (error) {
      console.error('Error fetching sites:', error);
    }
  };

  return (
    <div className="sharepoint-picker">
     
    </div>
  );
};

export default SharePointPicker;

